import React from 'react';
import PropTypes from 'prop-types';
//import { Link } from 'react-router-dom';
const Breadcrumbs = (props) => (
    <div className="content-header">
        <div className="row">
            <div className="col-sm-6">
                <div className="header-section">
                    <h1>{props.title}</h1>
                </div>
            </div>
            {/* <div className="col-sm-6 hidden-xs">
                <div className="header-section">
                    <ul className="breadcrumb breadcrumb-top">
                        <li>Admin</li>
                        <li>
                            <Link to="/">Form</Link>
                        </li>
                    </ul>
                </div>
            </div> */}
        </div>
    </div>
);
Breadcrumbs.propTypes = {
    title: PropTypes.string.isRequired,
    children: PropTypes.node
};
export default Breadcrumbs;
